
import React, { useEffect, useState } from  "react";
import  "../AddPost/AddPost.css";
import AttachFileIcon from  '@mui/icons-material/AttachFile';
import { useGlobalContext } from  "../../context";
import SchedulePostTable from  "./SchedulePostTable";
import { sendSchedulePost, sendPostFiles } from "../../api";
import Started from  "../AddPost/Started";
import { useLocation } from  "react-router-dom";
import { DateTimePicker } from  '@mui/x-date-pickers/DateTimePicker';
import { Dropdown } from "primereact/dropdown";
import CloseIcon from  '@mui/icons-material/Close';
import SubmitPopup from "../AddPost/SubmitPopup";

function SchedulePost() {

    const {
        categorys,
        setCategorys,
        setOpenCompleted,
        countryData,
        activeCategory,
        setActiveCategory,
        setOpenSubmitPopup
    } = useGlobalContext()

    const [caption, setCaption] = useState();
    const [files,setFiles] = useState([]);
    const [checkinClients, setCheckinClients] = useState([]);
    const [dateTime, setDateTimeValue] = useState();
    const [fileLinks, setFileLinks] = useState([]);
    const [fileError, setFileError] = useState(false);
    const [postStarted, setPostStarted] = useState(false);
    // const [scheduleCategoryType, setScheduleCategoryType] = useState();
    const [country, setCountry] = useState("");
    const location = useLocation();

    useEffect(() => {
        const active = categorys.find(item => item.active === true);
        setActiveCategory(active.text);
    }, [categorys])

    const filesHandler = e => {
        if (e.target.files.length === 1 && e.target.files[0].type.includes("image")) {
            if (e.target.files[0].size < 4 * 1048576) {
                setFiles(files => {
                    return  [e.target.files[0]];
                });
                setFileError(false);
            }
            else {
                setFileError(true);
            }
        }

        else if (e.target.files.length === 1 && e.target.files[0].type.includes("video")) {
            setFiles(files => { return [e.target.files[0]] });
            setFileError(false);
        }

        else {
            for (let i = 0; i < e.target.files.length; i++) {
                if (e.target.files[i].size < 4 * 1048576) {
                    setFiles(files => { return [...files, e.target.files[i]] });
                    setFileError(false);
                }
                else {
                    setFileError(true);
                }
            }
        }
    }

    const changeActiveCategory = (item) => {
        setCategorys(categorys => categorys.map(ctgry => ctgry.id === item.id ? { ...ctgry, active: true } : { ...ctgry, active: false }));
    }

    const deleteFile = (e) => {
        setFiles(files => files.filter(item => item.name !== e.name));
    }

    const submitFetchData = async (list) => {
        let form = {};
        if (list.length > 1) {
            form.postingType = "MULTIPLE_IMAGE";
        }
        else if (list.length === 1) {
            const format = list[0].split('.')?.pop();
            if (format === "jpg" || format === "jpeg" || format === "png") {
                form.postingType = "SINGLE_IMAGE";
            }
            else if (format === "mp4" || format === "avi") {
                form.postingType = "VIDEO";
            }
        }

        form.caption = caption;
        form.attachments = list;
        form.clients = checkinClients
        form.scheduleDate = dateTime.$d.toString();
        form.scheduleType = country ? "CLIENT" : "CATEGORY";
        form.category = activeCategory?.replaceAll(" ", "_");
        const sendData = await sendSchedulePost(JSON.stringify(form));

        if (sendData) {
            setFileLinks([]);
            setFiles([]);
            setCaption("");
            setPostStarted(false);
            setOpenCompleted(true);
        }
        setPostStarted(false);
    }

    const submitPost = async (e) => {
        setPostStarted(true);
        setOpenSubmitPopup(false);
        let formData = new FormData();

        files.forEach( (item, index) => {
            formData.append(`images[${index}]`, item);
        })
        try{
            const response = await sendPostFiles(formData);
            setFileLinks(response.data)
        }
        catch(err) {
            console.log(err);
        }
    }

    const openPopup = () => {
        setOpenSubmitPopup(true);
    }

    useEffect(() => {
        if (fileLinks.length > 0 && fileLinks.length === files.length) {
            submitFetchData(fileLinks);
        }
    },[fileLinks])

    return (
        <div className = "addPost">
            {/*<FilterAllUsers/>*/}
            <div className = "addPostMainBox">
                <div className = "usersTableHeaderBox">
                    <h3
                        className = "usersTableHeaderText"
                        style = {{
                            marginLeft: "20px"
                        }}
                    >
                        SCHEDULE A POST
                    </h3>
                </div>
                <div className = "addPostCheckTextareaBox">
                    <span className = "addPostTextareaText">Caption</span>
                    <span className = "addPostTextareaAndFileAddBox">
                        <textarea
                            className = "addPostTextareaInput"
                            value = { caption }
                            onChange = { e => setCaption(e.target.value) }
                        >
                        </textarea>
                        <span className = "addPostAddFileSpan">
                            {
                                files &&
                                files.map(item =>
                                    <span
                                        className = "addPostFileName"
                                        style = {{
                                            margin: "0 10px",
                                            color: "rgba(0,0,0,0.6)"
                                        }}
                                    >
                                        { item.name }
                                        <CloseIcon
                                            style = {{
                                                fontSize: "18px",
                                                cursor: "pointer",
                                                margin: "0 5px"
                                            }}
                                            onClick = { deleteFile.bind(this, item) }
                                        />
                                    </span>
                                )
                            }
                            <AttachFileIcon
                                style = {{
                                    transform: "rotate(45deg)",
                                    color: "#666666",
                                    margin: "0 10px"
                                }}
                            />
                            <input
                                type = "file"
                                className = "addFileInput"
                                onChange = { filesHandler }
                                multiple = { true }
                                accept = ".jpg, .jpeg, .png, .mp4, .avi"
                            />
                        </span>
                    </span>
                </div>
                {
                    fileError ?
                        <p className = "fileErrorText">
                            File size must not exceed 4MB
                        </p>
                        : null
                }
                <div
                    className = "postBtnBox"
                    style = {{
                        justifyContent: "space-between"
                    }}
                >
                    <div className="schedulePostDateTimeCategoryBox">
                        <DateTimePicker
                            label="Add Date & Time"
                            className="dateTimePicker"
                            value={dateTime}
                            onChange={e => setDateTimeValue(e)}
                        />
                        {/*<Dropdown*/}
                        {/*    options = { scheduleCategory }*/}
                        {/*    optionLabel = "text"*/}
                        {/*    placeholder = "Select By"*/}
                        {/*    className = "schedulePostDropdown"*/}
                        {/*    value = { scheduleCategoryType }*/}
                        {/*    onChange = { e => setScheduleCategoryType(e.value) }*/}
                        {/*/>*/}
                        <select
                            className="addPostCountryFilter"
                            value={country}
                            onChange={e => setCountry(e.target.value)}
                            style = {{height: "55px", fontSize: "20px"}}
                        >
                            <option selected={true} value="">All Country</option>
                            {
                                countryData.map(elem => <option key={elem.id} value={elem.country}>{elem.country}</option>)
                            }
                        </select>
                    </div>
                    <button
                        className="postSubmitBtn"
                        style={{
                            backgroundColor: files.length > 0 ? "#3F68B1" : "#FAFAFA",
                            color: files.length > 0 ? "white" : "#929292",
                        }}
                        onClick={files.length > 0 ? openPopup : null}
                    >
                        POST
                    </button>
                </div>
                {
                    !country ?
                    <div className = "addPostCategoryFilter">
                        {
                            categorys.map(item => item.id !==0 &&
                                <span
                                    key = { item.id }
                                    className = "addPostCategorySpan"
                                    style = {{
                                        backgroundColor: item.active ? "#3F68B1" : "#FAFAFA",
                                        color: item.active ? "white" : "#929292",
                                        border: item.active ? "none" : "1px solid #929292"
                                    }}
                                    onClick = { changeActiveCategory.bind(this, item) }
                                >
                                    { item.text }
                                </span>
                            )
                        }
                    </div>
                    : null
                }
                <SchedulePostTable
                    activeCategory = { activeCategory }
                    checkinClients = { checkinClients }
                    setCheckinClients = { setCheckinClients }
                    scheduleCategoryType = { "CATEGORY" }
                    country = { country }

                />
            </div>
            <SubmitPopup
                submitPost = { submitPost }
                files = { files }
                caption = { caption }
                checkinClients = { checkinClients }
                dateTime = { dateTime }
                scheduleCategoryType = { "CATEGORY" }
                activeCategory = { activeCategory }
                location = { location }
            />
            <Started
                postStarted = { postStarted }
                setPostStarted = { setPostStarted }
            />
        </div>
    )
}

export default SchedulePost